<script setup lang="ts">
import type { ButtonHTMLAttributes } from 'vue';
import './style.scss';

type ButtonHTMLAttributesType = ButtonHTMLAttributes['type'];

const props = defineProps({
    class: {
        type: [String, Object] as PropType<string | object>,
        default: ''
    },
    name: {
        type: String,
        default: ''
    },
    type: {
        type: [String, undefined] as PropType<ButtonHTMLAttributesType>,
        default: 'button'
    }
});

const emit = defineEmits<{
    click: [];
}>();
</script>

<template>
    <button :type="props.type" class="btn" :class="props.class" @click="emit('click')">
        <slot></slot>
    </button>
</template>
